import { useId } from "react";
import { Lock } from "lucide-react";

const TINTS = { common: "#455461", uncommon: "#286040", rare: "#294776", epic: "#663878", legendary: "#80622d", goddess: "#87395d", mythic: "#803d3d" };

/** Cosmetic blocker only. Restricted artwork must never be fetched or rendered here. */
export const LockedCardArtwork = ({ card, compact = false, view = "card" }) => {
  const instance = useId();
  const id = `${card.id}-${view}-${instance}`;
  return (
    <div className="absolute inset-0 overflow-hidden rounded-[inherit]" data-testid={`locked-artwork-${id}`} style={{ backgroundColor: TINTS[card.rarity] || TINTS.common }}>
      <div data-testid={`locked-blocker-${id}`} data-locked-blocker="true" className="absolute inset-0 flex flex-col items-center justify-center gap-2" style={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}>
        <Lock data-testid={`locked-indicator-${id}`} className={`${compact ? "h-4 w-4" : "h-7 w-7"} shrink-0 text-white/85`} aria-hidden="true" />
        {!compact && <span data-testid={`locked-label-${id}`} className="font-display text-base text-white/80">LOCKED</span>}
        {compact && <span className="sr-only">Locked card</span>}
      </div>
    </div>
  );
};